import "./ControlBtns.css"
import color from "../../assets/color.png"
import move from "../../assets/move.png"
import image from "../../assets/image.png"
import {useDispatch } from "react-redux"
import { setSetting } from "../../actions"

const ControlBtns = () => {

    const dispatch = useDispatch()

    const handleClick = (choice,e) => {
        dispatch(setSetting(choice))
        const buttons = document.querySelectorAll(".controlBtn")
        buttons.forEach(button => button.classList.remove("selected"))
        e.currentTarget.classList.add("selected")
    }

    return(
        <div className="ControlBtns">
            <button className="controlBtn selected" onClick={(e)=>handleClick("color",e)}><img src={color} alt="" /></button>
            <button className="controlBtn" onClick={(e)=>handleClick("move",e)}><img src={move} alt="" /></button>
            <button className="controlBtn" onClick={(e)=>handleClick("image",e)}><img src={image} alt="" /></button>
        </div>
    )
}

export default ControlBtns